import { clientFetch, Uri } from '../utils/fetch';
import combinationModel from '../models/combination';
import { getNoExtrasFromUrl, getSelectedCabinFromUrl } from '../utils/url/url';

export const fetchCombinations = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...combinationModel,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/packages',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchSummary = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl, newCheckout } = siteSettings;

  const query = {
    siteId,
    userId,
    newCheckout,
    ...combinationModel,
    selectedCabin: getSelectedCabinFromUrl(),
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/summary',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchHotels = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...combinationModel,
    selectedCabin: getSelectedCabinFromUrl(),
    noExtras: getNoExtrasFromUrl(),
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/accomodations',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchTransports = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...combinationModel,
    selectedCabin: getSelectedCabinFromUrl(),
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/transports',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchPriceMatrix = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;

  const query = {
    siteId,
    userId,
    ...combinationModel,
    selectedCabin: getSelectedCabinFromUrl(),
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/price-matrix',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const addToCart = async (siteSettings, userId, flightRouteKeys, cruiseKey) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const { accomodationKeys, transportKey, sessionId } = combinationModel;

  const query = {
    siteId,
    userId,
    sessionId,
    accomodationKeys,
    transportKey,
    routeKeys: flightRouteKeys.join(','),
    cruiseKeys: cruiseKey,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/combination/addToCart',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};

export const fetchTransfers = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl, newCheckout } = siteSettings;

  const query = {
    siteId,
    userId,
    newCheckout,
    sessionId: combinationModel.sessionId,
    rooms: combinationModel.rooms,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/extras/transfersForTrip',
    query,
  });

  const response = await clientFetch.getJsonByProxy(uri, baseUrl);
  return response;
};
